import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext';
import CityQrModal from '../components/CityQrModal';

const Home = () => {
    const navigate = useNavigate();
    const { config } = useConfig();
    const { user } = useAuth();
    const [isQrModalOpen, setIsQrModalOpen] = useState(false);

    const secondaryColor = config?.secondaryColor || "#ff5874";
    const tertiaryColor = config?.tertiaryColor || "#008b8b";
    const primaryColor = config?.primaryColor || "#00595b";

    const defaultButtons = [
        {
            label: "Agenda",
            path: "/agenda",
            color: secondaryColor
        },
        {
            label: "Conferencistas",
            path: "/speakers",
            color: tertiaryColor
        },
        {
            label: "Preguntas al expositor",
            path: "/questions-expert",
            color: secondaryColor
        },
        {
            label: "Confirmar asistencia",
            path: "/confirm-attendance",
            color: tertiaryColor
        }
    ];

    const menuButtons = config?.pageDesigns?.home?.buttons || config?.home_buttons || defaultButtons;

    const activeButtons = menuButtons.filter(btn => {
        const pathLower = (btn.path || '').toLowerCase();
        const labelLower = (btn.label || '').toLowerCase();
        const isAttendanceBtn = pathLower.includes('confirm-attendance') || pathLower.includes('attendance') || labelLower.includes('asistencia') || labelLower.includes('confirmar');
        
        if (isAttendanceBtn) {
            // Ocultar el botón si el usuario YA confirmó su asistencia presencial en el evento o pre-confirmación
            const isAsistenciaEvento = user?.asistencia_evento === true || user?.asistencia_evento === 1 || user?.asistencia_evento === '1' || user?.asistencia_evento === 'true' || user?.asistencia_evento === 'SI';
            const isAsistire = user?.asistire === true || user?.asistire === 1 || user?.asistire === '1' || user?.asistire === 'true' || user?.asistire === 'SI';
            
            if (isAsistenciaEvento || isAsistire) {
                return false;
            }

            const design = config?.pageDesigns?.['attendance'];
            if (design && design.enabled === false) return false;

            return true;
        } else {
            let key = null;
            if (btn.path.includes('agenda')) key = 'agenda';
            else if (btn.path.includes('speakers')) key = 'speakers';
            else if (btn.path.includes('questions-expert')) key = 'questions_private';

            if (key) {
                const design = config?.pageDesigns?.[key];
                if (design && design.enabled === false) return false;
            }
        }
        return true;
    });

    const handleButtonClick = (btn) => {
        const isAttendanceBtn = (btn.path || '').includes('confirm-attendance') || (btn.label || '').toLowerCase().includes('asistencia');
        
        if (isAttendanceBtn) {
            navigate('/confirm-attendance');
        } else if (btn.isExternal || btn.path.startsWith('http')) {
            window.open(btn.path, '_blank', 'noopener,noreferrer');
        } else {
            navigate(btn.path);
        }
    };

    const getButtonIcon = (path, label) => {
        const p = (path || '').toLowerCase();
        const l = (label || '').toLowerCase();
        if (p.includes('agenda') || l.includes('agenda')) return 'https://ftp.pcnpublicidad.com/virs/icons/Agenda.svg';
        if (p.includes('speaker') || l.includes('conferencista')) return 'https://ftp.pcnpublicidad.com/virs/icons/Conferencistas.svg';
        if (p.includes('question') || l.includes('pregunta')) return 'https://ftp.pcnpublicidad.com/virs/icons/Preguntas_Interactivas.svg';
        if (p.includes('attendance') || p.includes('confirm') || l.includes('asistencia')) return 'https://ftp.pcnpublicidad.com/virs/icons/Confirmar_Asistencia.svg';
        return null;
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-[70vh] w-full relative z-10 select-none animate-fadeIn py-6">
            <div className="w-full max-w-sm px-6 flex flex-col gap-4 items-center">
                {activeButtons.map((btn, idx) => {
                    const btnColor = btn.color || (idx % 2 === 0 ? secondaryColor : tertiaryColor);
                    const iconUrl = getButtonIcon(btn.path, btn.label);

                    return (
                        <button
                            key={idx}
                            onClick={() => handleButtonClick(btn)}
                            style={{ backgroundColor: btnColor }}
                            className="w-full text-white py-4 px-6 rounded-2xl font-black capitalize tracking-widest text-[14px] sm:text-[16px] shadow-lg hover:scale-[1.03] active:scale-95 transition-all duration-300 flex items-center justify-center gap-3 text-center"
                        >
                            {iconUrl && (
                                <img
                                    src={iconUrl}
                                    alt=""
                                    className="w-5 h-5 object-contain filter brightness-0 invert opacity-90"
                                />
                            )}
                            <span>{btn.label}</span>
                        </button>
                    );
                })}
            </div>

            <CityQrModal
                isOpen={isQrModalOpen}
                onClose={() => setIsQrModalOpen(false)}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
            />
        </div>
    );
};

export default Home;
